import { FC } from "react";
import DOMPurify from "dompurify";
import { styled } from "@mui/material/styles";

export interface DisclosureItem {
  displayOrder: number;
  language: string;
}

export interface DisclosureProps {
  disclosures: DisclosureItem[];
}

const StyledWrapper = styled("div")(({ theme }) => ({
  margin: "0 auto",
  maxWidth: theme.breakpoints.values.lg,

  "& a": {
    color: theme.colors.sapphire,
    textDecoration: "none",
    "&:hover": {
      color: theme.colors.navy,
      textDecoration: "none !important",
    },
  },

  "& strong": {
    fontFamily: theme.fonts.bold,
    fontWeight: "normal",
  },
}));

const StyledText = styled("p")(({ theme }) => ({
  color: theme.colors.black,
  fontFamily: theme.fonts.regular,
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: 1.8,
  marginBottom: 24,
}));

const Disclosure: FC<DisclosureProps> = ({ disclosures }) => {
  return (
    <StyledWrapper>
      {disclosures.map((desc) => {
        const html = DOMPurify.sanitize(desc.language, {
          USE_PROFILES: { html: true },
        });
        return (
          <StyledText
            key={desc.displayOrder}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        );
      })}
    </StyledWrapper>
  );
};

export default Disclosure;
